import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

import { useAiInsights } from '../../baseDealActivity/baseDealContainer/hooks/useAiInsights';
import { AiLogoIcon } from '../../common/AiLogoIcon';
import { ScenarioAiInsights } from './ScenarioAiInsights';
import { AiRowRoot } from './ScenarioAiRow.style';

export const AI_INSIGHTS_LABEL = 'AI insights';

export const ScenarioAiRow = ({ scopeId }: { scopeId: string }) => {
    const theme = useInterstateTheme();
    const insights = useAiInsights({ scopeId });

    if (!insights.showAISection) {
        return null;
    }

    return (
        <AiRowRoot theme={theme} data-testid="scenario-ai-row">
            <AiLogoIcon data-testid="scenario-ai-row-logo" fontSize="20px" ariaLabel={AI_INSIGHTS_LABEL} />
            <ScenarioAiInsights scopeId={scopeId} insights={insights} />
        </AiRowRoot>
    );
};
